<!--
Copyright 2017 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->
<template>
  <modal :state="state" hideable backdrop @hide="$emit('hide')">
    <template #title>{{ $t('title') }}</template>
    <template #body>
      <div class="modal-introduction">
        <p>{{ $t('introduction[0]') }}</p>
        <i18n tag="p" path="moreInfo.helpArticle.full">
          <template #helpArticle>
            <doc-link to="central-projects/">{{ $t('moreInfo.helpArticle.helpArticle') }}</doc-link>
          </template>
        </i18n>
      </div>
      <div class="modal-actions">
        <button type="button" class="btn btn-primary" @click="$emit('hide')">
          {{ $t('action.ok') }}
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import DocLink from '../doc-link.vue';
import Modal from '../modal.vue';

export default {
  name: 'ProjectIntroduction',
  components: { DocLink, Modal },
  props: {
    state: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<i18n lang="json5">
{
  "en": {
    // This is the title at the top of a pop-up.
    "title": "What are Projects?",
    "introduction": [
      "Projects let you group related Forms and Users. Web Users can be given Roles that let them perform certain actions within the Project, including using a web browser to fill out Forms. App Users for the Project can only see Forms in the Project which they have access to."
    ]
  }
}
</i18n>

<!-- Autogenerated by destructure.js -->
<i18n>
{
  "cs": {
    "title": "Co jsou Projekty?",
    "introduction": [
      "Projekty umožňují seskupovat související formuláře a uživatele. Webovým uživatelům mohou být přiděleny role, které jim umožní provádět určité akce v rámci projektu, včetně použití webového prohlížeče k vyplnění formulářů. Uživatelé aplikace pro projekt mohou vidět pouze formuláře v projektu, ke kterým mají přístup."
    ]
  },
  "de": {
    "title": "Was sind Projekte?",
    "introduction": [
      "Projekte lassen Sie zusammengehörige Formulare und Benutzer gruppieren. Web-Benutzer können Rollen erhalten, die es ihnen ermöglicht, bestimmte Aktionen innerhalb des Projekts auszuführen, einschließlich der Verwendung eines Webbrowsers zum Ausfüllen von Formularen. App-Benutzer des Projekts können Formulare nur in dem Projekt sehen, zu dem Sie Zugriff haben."
    ]
  },
  "es": {
    "title": "¿Qué son los proyectos?",
    "introduction": [
      "Los proyectos permiten agrupar los formularios y usuarios relacionados. A los usuarios web se les puede asignar roles que les permitan realizar ciertas acciones dentro de este proyecto, incluyendo el uso de un navegador web para llenar formularios. Los usuarios móviles de este proyecto sólo podrán ver los formularios a los cuales se les otorgó el acceso."
    ]
  },
  "fr": {
    "title": "Qu'est ce qu'un projet?",
    "introduction": [
      "Un projet vous permet de regrouper des formulaires et des usagers. Les utilisateurs web peuvent avoir des rôles qui leur permettent d'exécuter certaines actions dans ce projet, incluant remplir un formulaire depuis leur navigateur. Les utilisateurs mobiles pour ce projet ne peuvent que voir les formulaires auxquels ils ont accès."
    ]
  }
}
</i18n>
